function fn_comp_gallery() {
    var $comp = $(".comp_gallery");

    $comp.find('[data-dynamic-gallery]').each(function(){
        var $gallery_data = $(this).data('dynamic-gallery'),
            $gallery_id = $(this).data('gallery-id'),
            $slide_index = 0;
        $(this).on('click', function(e) {
            var gallerySlideParam = parseInt(getParameterByName('slide'));
            if (!isNaN(gallerySlideParam))
            {
                $slide_index = gallerySlideParam;
            }
            e.preventDefault();
            $(this).lightGallery({
                dynamic: true,
                dynamicEl: $gallery_data,
                showThumbByDefault: true,
                hash: true,
                galleryId: $gallery_id,
                index: $slide_index,
                share: true,
            })
        });
    });

    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&#]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    var galleryIndexParam = parseInt(getParameterByName('lg'));
    if (!isNaN(galleryIndexParam))
    {
        $comp.find("[data-gallery-id=\""+galleryIndexParam+"\"]").click();
    }
}